export default {
  state: {
    flag: false,
    msg: '',
  },
  mutations: {
    undoSuccess: (state: any) => {
      state.flag = false;
    },
    onSuccess: (state: any, msg: any) => {
      state.msg = msg;
      state.flag = true;
    },
  },
};
